import classnames from 'classnames';
import React__default from 'react';
import ownClasses from './index.module.scss.js';

/**
 * The Button can be composed of various elements.
 * In the icon-only case, pass the "text" design, an icon, an aria-label,
 * and no children.
 */
const Button = React__default.forwardRef((props, ref) => {
    const { size = 'medium', design = 'solid', classes = [], children, icon, iconLeft, iconRight, slim = false, ...passThroughProps } = props;
    const leftIcon = iconLeft ?? icon;
    const rightIcon = iconRight;
    const c = classnames(
    // From the typography, to style the text
    'button-text', { small: size === 'small' }, // N.B. this is the typography modifier
    // The classes in the CSS module
    ownClasses['sbt-button'], ownClasses[design], ownClasses[size], // N.B. this is the button size from the CSS module
    { [ownClasses['icon-only']]: !children, [ownClasses.slim]: slim }, 
    // The array of classes passed in
    classes);
    return (React__default.createElement("button", { className: c, ref: ref, ...passThroughProps },
        leftIcon,
        children,
        rightIcon));
});
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=index.js.map
